import { AuthPromoSection } from '../AuthPromoSection/AuthPromoSection'
import { AuthTopNav } from '../../../components/TopNav/AuthTopNav'
import { AuthenticationForm } from '@dtx-company/inter-app/src/components/Authentication/AuthenticationForm'
import { FC } from 'react'
import { GridLayout } from '../../../components/layout/GridLayout/GridLayout'
import { SignupProps } from './SignupPageContainer.types'
import { Stack } from '@dtx-company/design-system/src'

export const SignupPageContainer: FC<SignupProps> = ({
  fromFlowpage,
  prismicData,
  planTypeQueryParams,
  inviteState,
  planContent
}) => {
  return (
    <GridLayout
      headerSlot={{
        children: <AuthTopNav color="onSurface.inverse" secondarySlotHiddenOnMobile />
      }}
      primarySlot={{
        children: (
          <Stack sx={theme => ({ maxWidth: theme.spacing(115) })}>
            <AuthenticationForm
              action="sign up"
              product={fromFlowpage ? 'flowpage' : 'flowcode'}
              planTypeQueryParams={planTypeQueryParams}
              inviteState={inviteState}
            />
          </Stack>
        ),
        verticalAlignment: prismicData.primary_vertical_alignment
      }}
      secondarySlot={{
        children: (
          <AuthPromoSection
            prismicData={prismicData}
            inviteState={inviteState}
            planContent={planContent}
          />
        ),
        backgroundColor: prismicData.bg_color,
        backgroundImgSrc: prismicData.background?.url ?? undefined,
        graphicPosition: 'background',
        hideOnMobile: true
      }}
    />
  )
}
